const actions = {
    GET_FARM_EQUIPMENTS:'GET_FARM_EQUIPMENTS',
    SET_FARM_EQUIPMENTS:' SET_FARM_EQUIPMENTS'
  
 }
 export default actions;